import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { FetchForgeContextTokenFunction } from '../../types.tsx';

export const fetchForgeServiceDeskContextToken: FetchForgeContextTokenFunction = ({
	extension,
	extensionData,
}) => {
	const options = {
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify({ extension, extensionData }),
	};
	return performPostRequest('/rest/servicedesk/1/servicedesk-data/forge/context-token', options);
};
